import { Grid, LinearProgress, Paper } from "@material-ui/core";
import { vendorDashStyle } from "./style";
import { StatsWidget } from "./StatsWidget/StatsWidget";
import { ServicesGraphWidget } from "./ServicesGraphWidget/ServicesGraphWidget";
import { TopPerformingVendorsWidget } from "./TopPerformingVendorsWidget/TopPerformingVendorsWidget";
import { VendorComparisonWidget } from "./VendorComparisonWidget/VendorComparisonWidget";
import { useGetVmsDasboardStatsQuery } from "../vmsSlice";
import { useSelector } from "react-redux";
import { selectClientAccountId, selectClientId, selectEndDate, selectStartDate, selectVendorId } from "./dashboardFiltersSlice";
import FormatService from "services/formatService";
import { VendorDashboardFilters } from "./VendorDashboardFilters";
import { vmsStatsFields } from "../consts";

export const VendorDashboard = () => {
    const classes = vendorDashStyle();
    const vendorId = useSelector(selectVendorId);
    const clientId = useSelector(selectClientId);
    const clientAccountId = useSelector(selectClientAccountId);
    const startDate = useSelector(selectStartDate);
    const endDate = useSelector(selectEndDate);

    let { data: stats, error, isLoading, isFetching } = useGetVmsDasboardStatsQuery({
        vendorId,
        clientId,
        clientAccountId,
        endDate,
        startDate
    });

    const mapExportData = (row, fieldList) => {
        let allDataMap = {
            ['Vendor']: row.vendorName
        };
        vmsStatsFields.filter(f => !fieldList?.length || fieldList.includes(f.key)).map(f => {
            allDataMap[f.label] = row[f.key]
        });

        return allDataMap;
    };

    return (
        <div>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <VendorDashboardFilters isLoadingDashboardData={isFetching} />
                </Grid>
                <Grid container item xs={12} spacing={2} wrap="nowrap" style={{ width: '100%' }}>
                    {[{
                        title: 'Overall Vendor Score',
                        description: 'Based on performance metrics across all active vendors',
                        statsText: stats?.overallScore?.toFixed(2) ?? 0,
                        data: stats?.allVendors,
                        mapExportData: (row) => mapExportData(row),
                        content: <LinearProgress
                            style={{ height: 6, borderRadius: 3 }}
                            color="primary"
                            variant='determinate'
                            size="lg"
                            value={stats?.overallScore}
                        />,
                        trend: stats?.vendorScoreTrends?.overallScoreTrend,
                    }, {
                        title: 'Active Vendors',
                        description: 'Based on performance metrics across all active vendors',
                        statsText: `${stats?.allVendorsWithServices?.length ?? 0} / ${stats?.allVendors?.length ?? 0}`,
                    }, {
                        title: 'Avg. Turnaround Time',
                        description: 'Based on performance metrics across all active vendors',
                        statsText: (() => {
                            const hours = stats?.turnaroundTime ?? 0;
                            if (hours >= 24) {
                                const days = Math.floor(hours / 24);
                                const remHours = Math.round(hours % 24);
                                return `${days}d${remHours > 0 ? ` ${remHours}h` : ''}`;
                            }
                            return `${Math.round(hours)} hrs`;
                        })(),
                        data: stats?.allVendors,
                        mapExportData: (row) => mapExportData(row, ['turnaroundTime']),
                        tableData: stats?.turnaroundTimeInfoWithWo,
                        trend: stats?.vendorScoreTrends?.turnaroundTimeScoreTrend,
                    }, {
                        title: 'Rework Rate',
                        description: 'Based on performance metrics across all active vendors',
                        statsText: `${((stats?.reworkRate ?? 0) * 100)?.toFixed(2) ?? 0}%`,
                        data: stats?.allVendors,
                        mapExportData: (row) => mapExportData(row, ['reworkRate']),
                        tableData: stats?.reworkServiceInfoWithWo,
                        trend: stats?.vendorScoreTrends?.reworkRateScoreTrend,
                    }, {
                        title: 'Total Spend',
                        description: 'Based on performance metrics across all active vendors',
                        statsText: `${FormatService.formatCurrency(stats?.totalSpend ?? 0)}`,
                        data: stats?.allVendors,
                        mapExportData: (row) => mapExportData(row, ['totalSpend']),
                        tableData: stats?.services,
                        trend: stats?.vendorScoreTrends?.costTrendScoreTrend,
                    }].map((props, idx) => (
                        <Grid item key={props.title} style={{ flex: 1, minWidth: 0 }}>
                            <StatsWidget isLoading={isFetching} {...props} />
                        </Grid>
                    ))}
                </Grid>
                <Grid item xs={6}>
                    <ServicesGraphWidget isLoading={isFetching} activities={stats?.services} />
                </Grid>
                <Grid item xs={6}>
                    <TopPerformingVendorsWidget isFetching={isFetching} isLoading={isLoading} data={stats} />
                </Grid>
                <Grid item xs={12}>
                    <VendorComparisonWidget isLoading={isFetching} data={stats?.allVendors} />
                </Grid>

            </Grid>
        </div>
    );
}